module.exports = __webpack_public_path__ + "static/media/SWPN1677.f42e3e2b.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/images/team/SWPN1677.JPG
// module id = 165
// module chunks = 0